<template>
  <div class="row padd-0">
    <div class="col-12">
      <div class="row">
        <div class="col-1 vertAlign nopad-left" style="text-align:left;">
          <span :class="isOnline ? 'dot-green' : ''"></span>
        </div>
        <div
          class="col-3 vertAlign nopad-left"
          style="text-align:left;"
        >{{admin.userOptionalName || admin.user_google_name}}</div>
        <div class="col-3 vertAlign">{{admin.email}}</div>

        <div
          class="col-3 vertAlign noPaddsLR"
        >{{rolePool[admin.role] != undefined ? rolePool[admin.role] : 'Unknown'}}</div>

        <div class="col-2 vertAlign noPaddsLR" style="padding-right: 5px;">
          <div class="row">
            <div class="col-8">
              <b-button
                class="buttonStyle"
                variant="outline-primary"
                v-on:click="$emit('edituser', admin)"
                v-b-modal.modal-prevent-closing
              >
                <b-icon icon="pencil"></b-icon>Edit
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top:10px;">
        <div class="col-2 nopad mr-25">
          <b-form-checkbox
            v-model="admin.chatRoute"
            @change="dbUpd({chatRoute: !admin.chatRoute}, {routeChats: !admin.chatRoute})"
          >Assign client's chats</b-form-checkbox>
        </div>
        <div class="col-2 nopad mr-25">
          <b-form-checkbox
            v-model="admin.showNotifications"
            @change="dbUpd({showNotifications: !admin.showNotifications}, {notificationsAllowed: !admin.showNotifications})"
          >Receive notifications</b-form-checkbox>
        </div>
        <div class="col-2 nopad mr-25">
          <b-form-checkbox
            v-model="nteCheck"
            @change="SetEmailForNotif(false)"
          >Notifications to email</b-form-checkbox>
        </div>
        <div class="col-2 nopad mr-25">
          <b-form-checkbox
            v-model="admin.popupAllowed"
            @change="dbUpd({popupAllowed: !admin.popupAllowed}, {popupAllowed: !admin.popupAllowed})"
          >Popup window</b-form-checkbox>
        </div>

        <div class="col-2 nopad mr-25">
          <b-form-checkbox
            v-model="admin.transcriptToEmail"
            @change="dbUpd({transcriptToEmail: !admin.transcriptToEmail}, {transcriptToEmail: !admin.transcriptToEmail})"
          >Transcript to email</b-form-checkbox>
        </div>
      </div>

      <b-modal
        ref="SendToEmailModal"
        title="Notifications to email"
        @ok="SetEmailForNotif(true)"
        @hidden="nteCheck = admin.notificationsToEmail ? true : false"
      >
        <p>Send notifications to email:</p>
        <b-form-input aria-label="First name" v-model="emailForNotif" placeholder="Enter email"></b-form-input>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminSetting",
  props: {
    admin: Object,
    isOnline: Boolean
  },
  data() {
    return {
      rolePool: {
        0: "SuperAdmin",
        1: "Admin",
        2: "Manager",
        3: "Appointment Coordinator"
      },
      emailForNotif: "",
      nteCheck: false
    };
  },
  computed: {},
  mounted() {
    this.nteCheck = this.admin.notificationsToEmail ? true : false;
  },
  methods: {
    SetEmailForNotif(setmode) {
      if (!this.nteCheck) {
        this.emailForNotif = this.admin.email;
        this.$refs["SendToEmailModal"].show();
      } else {
        if (setmode) {
          if (this.emailForNotif && this.emailForNotif.includes("@")) {
            this.admin.notificationsToEmail = this.emailForNotif;
            this.dbUpd(
              { notificationsToEmail: this.emailForNotif },
              { emailToNotes: this.emailForNotif }
            );
          }
        } else {
          this.admin.notificationsToEmail = "";
          this.dbUpd({ notificationsToEmail: "" }, { emailToNotes: "" });
        }
      }
    },
    dbUpd(ftobj, dbobj) {
      this.$emit("dbupdate", {
        id: this.admin.id,
        ftdata: ftobj,
        dbdata: dbobj
      });
    }
  }
};
</script>
<style>
.mr-25 {
  margin-right: 25px;
}
.padd-0 {
  padding: 0;
}
.nopad-left {
  padding-left: 0;
}
.vertAlign {
  line-height: 45px;
}
.nopad {
  padding: 0;
}

.buttonStyle {
  padding: 3px 10px 0px 10px;
}
.dot-green {
  height: 12px;
  width: 12px;
  background-color: green;
  border-radius: 50%;
  display: inline-block;
}
</style>




